
import CTable from '@/components/c-table'
import CUpload from '@/components/c-upload'
import CExportFile from '@/components/c-export-file'
import { getTableConfig, removeSourceEnum } from './config'
import { transferConfirm } from './api'
import { dropdownOfEnterprise } from '../api'
import { setBaseUrl } from '@/config/url'
import { getToken } from '@/utils/auth'
import { ElMessage, ElMessageBox } from 'element-plus'
import moment from 'moment'
import { useRouter } from 'vue-router'
import { defineComponent, reactive, toRefs, computed, ref } from 'vue'

export default defineComponent({
  name: 'vehicle-device-transfer', // 转移复制车载设备
  components: {
    CTable,
    CUpload,
    CExportFile
  },
  setup() {
    const router = useRouter()

    const data = reactive({
      formData: {
        sourceCompanyUuid: '',
        targetCompanyUuid: '',
        removeSource: removeSourceEnum.设为暂停
      }
    })

    // 源企业远程搜索
    const remoteData1 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData1.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    // 目标企业远程搜索
    const remoteData2 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData2.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    // 转移预览上传地址
    const previewAction =
      setBaseUrl().baseUrl + '/ccclubs-admin/device/terminal/transferPreview'
    // 上传请求头
    const uploadHeaders = { token: getToken() }
    // 转移复制模板文件名：车载设备转移复制导入模板+年月日时分秒
    const transferFileName = `车载设备转移复制导入模板${moment().format('YYYYMMDDHHmmss')}`
    // 上传附带参数（源/目标企业与源企业设备设置）
    const uploadData = computed(() => ({
      sourceCompanyUuid: data.formData.sourceCompanyUuid,
      targetCompanyUuid: data.formData.targetCompanyUuid,
      removeSource: data.formData.removeSource
    }))

    const tableConfig = reactive({
      ...getTableConfig()
    })

    // 预览结果
    const previewData = ref<any>(null)

    // 上传预览成功回调
    const onUploadSuccess = (file: any) => {
      const res = (file.response && file.response.data) || {}
      previewData.value = res
      tableConfig.data = res.records || []
    }

    // 上传移除回调
    const onUploadRemove = () => {
      previewData.value = null
      tableConfig.data = []
    }

    // 转移确认
    const handleConfirm = () => {
      const records = tableConfig.data.map((item: any) => ({
        sourceDeviceId: item.sourceDeviceId,
        targetDeviceId: item.targetDeviceId,
        action: item.action
      }))
      // 二次确认
      ElMessageBox.confirm('确定进行操作 吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          transferConfirm({
            sourceCompanyUuid: data.formData.sourceCompanyUuid,
            removeSource: data.formData.removeSource,
            targetCompanyUuid: data.formData.targetCompanyUuid,
            records
          }).then((res: any) => {
            ElMessage.success(res.data || res.msg || '转移完成')
            router.back()
          })
        })
        .catch(() => {})
    }

    // 取消返回
    const handleCancel = () => {
      router.back()
    }

    return {
      ...toRefs(data),
      removeSourceEnum,
      remoteData1,
      remoteData2,
      previewAction,
      transferFileName,
      uploadHeaders,
      uploadData,
      tableConfig,
      previewData,
      onUploadSuccess,
      onUploadRemove,
      handleConfirm,
      handleCancel
    }
  }
})
